import React from 'react';
import './WhyusGrow.css';
import {Link} from 'react-router-dom';

const WhyusGrow = () => {
  return (
    <section className="whyusgrow-section fade-in" id="growscale">
      <div className="container">
      <h2 className="whyusgrow-heading">HAVING THE ABILITY TO GROW AND SCALE WITH YOU</h2>
      <div className="whyusgrow-container">
        <div className="whyusgrow-box">
          <img
            src="/human.webp"
            alt="Team Icon"
            className="whyusgrow-icon"
          />
          <p>
            Lattice Labs provides a full suite of technical experts to cater to your every development need. With more than 70 developers, designers, and data scientists, we can tackle any challenge and scale up or down your team as needed.
          </p>
        </div>
        <div className="whyusgrow-box">
          <img
            src="/watch.webp"
            alt="Clock Icon"
            className="whyusgrow-icon"
          />
          <p>
            Following best-in-class agile development processes, our team is set for fast pace delivery, even in high-complexity projects.
          </p>
        </div>
      </div>
      <Link to="/services"><button className="whyusgrow-button">OUR ELITE DEVELOPMENT PROCESSES</button></Link>

      </div>
    </section>
  );
};

export default WhyusGrow;
